import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

import type { Commit } from "vuex";
import type { CardsData, CustomerCardsData } from "./types";

interface State {
  cardsData: CardsData;
  customerCardsData: CustomerCardsData;
}

const defaultCustomerCardsData = {
  modules_completed: 0,
  modules_sent: 0,
  protected: 0,
  active_users: 0,
  licences: 0,
};

const defaultState = () => {
  return {
    cardsData: {
      modules_sent: 0,
      at_risk: 0,
      protected: 0,
      active_users: 0,
      licences: 0,
      optionals: null,
    },
    customerCardsData: defaultCustomerCardsData,
  };
};

const state: State = defaultState();

export const getters = {
  modulesSent: (state: State) => state.cardsData.modules_sent,
  atRisk: (state: State) => state.cardsData.at_risk,
  protected: (state: State) => state.cardsData.protected,
  customerCards: (state: State) => state.customerCardsData,
};

export const actions = {
  async getCardData(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
    }: {
      globalOrganisationID: string;
    },
  ) {
    const res = await $http.get(
      `${getApiClientUrl()}/v1/cams/manager/sat/${globalOrganisationID}/customers/cards`,
    );

    commit("setCardsData", res.data);
  },
  async getCustomersCardsData(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
    }: {
      globalOrganisationID: string;
    },
  ) {
    const res = await $http.get(
      `${getApiClientUrl()}/v1/cams/manager/sat/${globalOrganisationID}/customers/cards`,
    );

    commit("setCustomersCardsData", res.data);
  },
};

const mutations = {
  setCardsData: (state: State, data: CardsData) => {
    state.cardsData = data;
  },
  setCustomersCardsData: (state: State, data: CustomerCardsData) => {
    state.customerCardsData = data;
  },
  resetCards: (state: State) => Object.assign(state, defaultState()),
  resetCustomerCards: (state: State) =>
    (state.customerCardsData = defaultCustomerCardsData),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
